// One import per namespace. Adding a namespace: create en/<ns>.json and
// pt-PT/<ns>.json, then register it here and in pt-PT/index.ts.
import auth from "./auth.json";
import billing from "./billing.json";
import common from "./common.json";
import contact from "./contact.json";
import customAssets from "./customAssets.json";
import dashboard from "./dashboard.json";
import dcf from "./dcf.json";
import dividends from "./dividends.json";
import errors from "./errors.json";
import goals from "./goals.json";
import holdings from "./holdings.json";
import importNs from "./import.json";
import nav from "./nav.json";
import notifications from "./notifications.json";
import onboarding from "./onboarding.json";
import performance from "./performance.json";
import portfolios from "./portfolios.json";
import research from "./research.json";
import retirement from "./retirement.json";
import roadmap from "./roadmap.json";
import settings from "./settings.json";
import site from "./site.json";
import taxes from "./taxes.json";
import transactions from "./transactions.json";

export const en = {
  auth,
  billing,
  common,
  contact,
  customAssets,
  dashboard,
  dcf,
  dividends,
  errors,
  goals,
  holdings,
  import: importNs,
  nav,
  notifications,
  onboarding,
  performance,
  portfolios,
  research,
  retirement,
  roadmap,
  settings,
  site,
  taxes,
  transactions,
};
